import storageService from './storage_service';

export default storageService;
